import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { Book, BookPlus, BookIcon } from 'lucide-react';

const NavigationBar = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await dispatch(logout());
    navigate('/');
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
        <img
          src="/static/Best-logo.webp" // or import logo from assets
          alt="Logo"
          width="75"
          height="75"
          className="d-inline-block align-top me-2"
        />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto me-2">
            <Nav.Link as={Link} to="/home">Home</Nav.Link>
            <Nav.Link as={Link} to="/about">About Us</Nav.Link>
            <Nav.Link as={Link} to="/training-programs">Training Programs</Nav.Link>
            <Nav.Link as={Link} to="/innovations">Innovations</Nav.Link>
            <Nav.Link as={Link} to="/news-updates">New & Updates</Nav.Link>
            <Nav.Link as={Link} to="/contacts">Contacts</Nav.Link>
          </Nav>
            {isAuthenticated && (
              <Nav className="me-auto">
              <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
              <Nav.Link as={Link} to="/books">
                  <BookIcon size={18} className="me-1" /> Books
              </Nav.Link>
              {user?.is_superuser && ( // <<< Show "Create Book" only to superusers
                <Nav.Link as={Link} to="/create-book">
                  <BookPlus size={18} className="me-1" /> Create Book
              </Nav.Link>
                )}
              </Nav>
            )}
          <Nav>
            {isAuthenticated ? (
              <>
                <span className="navbar-text me-3 text-light">
                  Welcome, {user?.email}
                </span>
                <Button variant="outline-light" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button 
                  variant="outline-light" 
                  className="me-2 my-2" 
                  as={Link} 
                  to="/login"
                >
                  Login
                </Button>
                <Button 
                  variant="light" 
                  className="my-2"
                  as={Link} 
                  to="/register"
                >
                  Register
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar; 